import React from 'react';
import classNames from 'classnames';
/**
 * Bronson [MediaGrid](https://bronson.vwfs.io/bluelabel/components/detail/bronson-media-grid.html)
 * component is a grid of {@link MediaGridItem}'s that are links around images displayed in a grid.
 * - {@link MediaGridItem} is a navigational element (link)
 * - Use it only when the item leads to another page, route, or destination
 * - Do not use it for in-place actions (e.g. opening modals, toggling UI, submitting data)
 */
export function MediaGrid({ aspectRatio, className, children, testId, ...otherProps }) {
    const ulClassNameList = classNames('c-media-grid', className).trim();
    return (React.createElement("ul", { className: ulClassNameList, ...otherProps, "data-testid": testId, "data-aspect-ratio": aspectRatio ?? null }, children));
}
MediaGrid.displayName = 'MediaGrid';
/**
 * The MediaGridItem component is internally used to wrap the item content
 * in a link and display it inside the {@link MediaGrid}.
 * - Always renders an anchor element (`<a>`)
 * - Must be used for navigation only
 * - Do not use for actions that do not change location
 *
 * @constructor
 */
export function MediaGridItem({ children, href, label, ...otherProps }) {
    return (React.createElement("li", { className: "c-media-grid__item" },
        React.createElement("a", { className: "c-media-grid__link", href: href, ...otherProps },
            React.Children.map(children, (child) => React.cloneElement(child, {
                className: 'c-media-grid__image',
            })),
            label && React.createElement("span", { className: "c-media-grid__label" }, label))));
}
MediaGridItem.displayName = 'MediaGrid.Item';
MediaGrid.Item = MediaGridItem;
